export default "__VITE_ASSET__423d5b08__"